import styled from '@emotion/styled';
import Button, { ButtonProps } from '@portalterreno/react-ui-core/Button';
import React from 'react';

export type StyledOutlineButtonProps = ButtonProps;
export type StyledAnchorTextProps = StyledOutlineButtonProps &
  React.HTMLAttributes<HTMLAnchorElement> & {
    as?: React.ElementType;
  };

const StyledButton = styled(Button)<StyledOutlineButtonProps>();

const StyledOutlineButton = styled(StyledButton)<StyledAnchorTextProps>(
  {
    backgroundColor: 'transparent',
    margin: '13px 0',
    padding: '13px 45px'
  },
  ({ theme }) => ({
    'border': `2px solid ${theme.palette.colors.white}`,
    'color': theme.palette.colors.white,
    'fontSize': theme.typography.fontSize.medium,
    '&:hover': {
      backgroundColor: theme.palette.colors.white,
      border: `2px solid ${theme.palette.colors.midnightBlue}`,
      color: theme.palette.colors.midnightBlue
    },
    'a': {
      '&:link, &:visited': {
        color: theme.palette.colors.white
      },
      '&:active, &:hover': {
        color: theme.palette.colors.midnightBlue
      }
    }
  })
);

export default StyledOutlineButton;
